let index: number = 0;

const DosageByStoreGridPluginSettings: IPluginSettings = {
    name: 'Дозировка',
    mnemocode: 'dosage_by_store_plugin',
    permission: 'RequestForMovement',
    columns: [{
        order: index++,
        propertyName: 'dosage',
        propertyType: 'string',
        displayName: 'Дозировка',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }],
}

export default DosageByStoreGridPluginSettings